import Fab from '@mui/material/Fab';
import { styled } from '@mui/material/styles';

export const StyledFab = styled(Fab)(({ theme }) => ({
  bottom: theme.spacing(8.75), // 70px
  '&.fixed': {
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: 3,
  },
  '&.disabled': {
    backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
    color: 'rgba(0, 0, 0, 0.26) !important',
  },
}));

export const StyledIcon = styled('span')(({ theme }) => ({
  paddingRight: theme.spacing(1),
  display: 'inherit',
}));

export const StyledLabel = styled('span')({
  fontSize: '15px',
  fontWeight: 700,
});
